// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__2-xEX","input":"Divider_input__2QKgM"};